import React from "react"
import {Modal} from "antd"
import {SetPhoneNumberForm} from "./SetPhoneNumberForm"

type Props = {
  visible: boolean
  onUpdatePhoneNumber: (phoneNumber: string) => void
  onClose: () => void
}

export const UpdatePhoneNumberDialog: React.FC<Props> = ({
  visible,
  onUpdatePhoneNumber,
  onClose,
}): React.ReactElement => <Modal
  title="Update Phone Number"
  visible={visible}
  onCancel={onClose}
  footer={null}>
  <SetPhoneNumberForm
    onSubmit={onUpdatePhoneNumber}/>
</Modal>

